import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Button from 'components/Button';
import { RemoveItemModalFooter, RemoveItemModalText } from '../../../assessment/components/ecosystemData/style';

const RemoveHabitatModal = ({ closeModal, confirmRemove, item, habitatsOptions }) => {
  const habitats = item.Level3HabitatId
    ? habitatsOptions.level3Habitats
    : habitatsOptions.level2Habitats; 
  const habitatItemId = item.Level3HabitatId || item.Level2HabitatId; 

  const name = habitats.find((element) => element.value === habitatItemId);

  return (
    <>
      <RemoveItemModalText data-test="modal-body">
        <FormattedMessage id="removeModalText" values={{ name: <b>{name ? name.label : item.name}</b> }} />
      </RemoveItemModalText>
      <RemoveItemModalFooter>
        <Button type="secondary" onClick={closeModal}>
          <FormattedMessage id="cancel" />
        </Button>
        <Button type="destructive" onClick={confirmRemove}>
          <FormattedMessage id="yesRemove" />
        </Button>
      </RemoveItemModalFooter>
    </>
  );
};

export default RemoveHabitatModal;

RemoveHabitatModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  confirmRemove: PropTypes.func.isRequired,
  item: PropTypes.shape({
    Level1HabitatId: PropTypes.number,
    Level2HabitatId: PropTypes.number,
    Level3HabitatId: PropTypes.number,
    name: PropTypes.string
  }).isRequired,
  habitatsOptions: PropTypes.shape({
    level1Habitats: PropTypes.array,
    level2Habitats: PropTypes.array,
    level3Habitats: PropTypes.array
  }).isRequired
}